import { SuggestPlaceResponse, PlaceType } from '../../../services/place/place';
import { SelectableItemProps } from '../../components/selectable-item/SelectableItem';
import { mapTypeToLabel, mapTypeToIcon } from './constants';

export default function mapToSelectableItemProps(suggestion: SuggestPlaceResponse): SelectableItemProps {
  const suffix = (suggestion.place.type === PlaceType.AREA && suggestion.place.parent)
    ? ` - ${suggestion.place.parent.name}`
    : '';

  return {
    id: suggestion.place.id,
    title: `${suggestion.highlightedSuggestion}${suffix}`,
    label: mapTypeToLabel[suggestion.place.type],
    icon: mapTypeToIcon[suggestion.place.type],
    data: suggestion.place,
  };
}
